import React from "react";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./Home";
import DigitalMediaServicesPage from "./DigitalMediaServicesPage";
import { sections, themeTitle } from "./components/theme/dataset";

function App() {
  // Simple routing based on URL path
  const path = window.location.pathname;
  const isDigitalMediaPage = path === '/digital-media-services' || path === '/digital-media-services/';

  return (
    <div className="App">
      <Header title={themeTitle} sections={sections} />
      {isDigitalMediaPage ? (
        <DigitalMediaServicesPage />
      ) : (
        <Home themeTitle={themeTitle} />
      )}
      <Footer
        themeTitle={themeTitle}
        description="All Rights Reserved | Powered by Cybros. Dev <Dynamic solution provider>"
      />
    </div>
  );
}

export default App;
